export default {
	Slide: 'Пазл',
	Puzzle: 'Пазл',
	'The puzzle is open!': 'Головоломка открыта!',
	'Congratulations!': 'Поздравляем!',
	'You get it': 'Вы получаете',
	'You get the task done': 'Вы выполняете задание',

	'Show all blocked': 'Показать всех заблокированных',

	Author: 'Автор',
	'Reset filters': 'Сбросить фильтры',

	Blocked: 'Восстановили',
	Unlocked: 'Разблокировали',

	Change: 'Изменить',

	'The student is blocked': 'Ученик заблокован',
	'The student is blocked with a new price':
		'Ученик заблокован с новым тарифом',
	'To unlock this student, go to the "Restore" section':
		'Чтобы разблокировать этого ученика, зайдите в раздел “Восстановление”',

	'Before blocking, you can change the price for the student':
		'Перед блокировкой вы можете изменить тариф для студента',

	'Block student': 'Заблокировать ученика',

	'First month cost': 'Цена на 1 месяц',

	'WARNING! After re-saving the task, the students who completed this task will have the puzzle closed and will have to do it again.':
		'Внимание! После повторного сохранения задания, у учеников, выполнивших эту задачу, закроется пазл и нужно будет снова выполнять задание.',

	"You cannot do homework in the student's platform":
		'Вы не можете делать домашнее задание в студенческой платформе',

	'Restore the student ?': 'Восстановить ученика ?',
	'Restore the teacher ?': 'Восстановить учителя ?',
	'Restore the franchise ?': 'Восстановить франчази ?',

	'Transition to 50': 'Переход через 50',
	'Transition to 100': 'Переход через 100',

	fifty: 'Переход через 50',
	hundred: 'Переход через 100',

	Faces: 'Лица',

	Heroes: 'Герои',
	Clothes: 'Одежда',
	Backgrounds: 'Фоны',
	Souvenirs: 'Сувениры',

	'Coming soon': 'Вскоре',

	'Wow! Congratulations, you have successfully purchased this product.':
		'Ух ты! Поздравляем, вы успешно приобрели этот продукт.',
	'You can view all your purchases in the "Purchased" section':
		'Вы можете просмотреть все свои покупки в разделе "Купленные"',

	'Your savings': 'Твои накопления',
	'You can spend them on something interesting!':
		'Ты можешь их потратить на что-то интересное!',

	'A student with this email address already exists':
		'Пользователь с таким адресом электронной почты уже существует',

	'User with such email already exists':
		'Пользователь с таким адресом электронной почты уже существует',
	'Year of birth': 'Год рождения',
	Registration: 'Регистрация',
	'Surname of parents': 'Фамилия родителей',
	School: 'Школа',
	'Field is required': 'Поле, обязательное для заполнения',
	'Select age': 'Выберите возраст',
	'No such teacher for this year': 'Нет такого учителя в этом году',
	'User with such phone number already exists':
		'Пользователь с таким номером телефона уже существует',
	'You are successfully registered': 'Вы успешно зарегистрированы',
	'Max length 20 chars': 'Максимальная длина 20 chars',
	'Після реєстрації вам надійде лист з логіном і паролем':
		'После регистрации вам придет письмо с логином и паролем',

	'INTERNATIONAL SCHOOL': 'МЕЖДУНАРОДНАЯ ШКОЛА',
	'Mental Arithmetic': 'Ментальная арифметика',
	'For children aged 5-14.': 'Для детей 5-14 лет.',
	'Sign up for a trial lesson': 'Запишитесь на пробный урок',
	'Parents name': 'Имя родителя',
	'Childs age': 'Возраст ребенка',
	Country: 'Страна',
	'Sign up': 'Записаться',

	'Open offer agreement': 'Договор открытой оферты',
	'Participate in online Indigo Olympiad':
		'Соревнуйся в онлайн олимпиаде Indigo!',
	Participate: 'Принять участие',
	export: 'Экспорт',

	wrong: 'Неправильно',
	right: 'Правильно',
	match: {
		addition: 'Форсаж',
		multiply: 'Умножение',
		divide: 'Деления',
		abacus_random: 'Абакус рандом',
		anzan: 'Анзани',
		negative: 'Отрицательные числа',
		column: 'Столбцы',
	},
	timeIsOver: 'Время выйшло',
	timer: 'Таймер',
	'Back to Lessons': 'Назад к списку уроков',
	'Create Lesson': 'Создать урок',
	Assign: 'Назначить',
	Home: 'На главную',
	'To cabinet': 'В кабинет',
	'Create a homework': 'Создать домашнее задание',
	January: 'Январь',
	February: 'Февраль',
	March: 'Март',
	April: 'Апрель',
	May: 'Май',
	June: 'Июнь',
	July: 'Июль',
	August: 'Август',
	'Group nickname': 'Ник группы',
	September: 'Сентябрь',
	October: 'Октябрь',
	November: 'Ноябрь',
	December: 'Декабрь',
	Overall: 'В общем',
	Active: 'Активных',
	'Contract number': 'Номер контракта',
	'For parents': 'Для родителей',
	'Choose lessons': 'Выберите уроки',
	Save: 'Назначить',
	'Students active': 'Активные ученики',
	Close: 'Закрыть',
	'Change birthday': 'Изменить дату рождения',
	Sent: 'Выслано',
	'Choose date': 'Выберите дату',
	'Include students': 'Включить студентов',
	'Add service': 'Добавить услугу',
	'Create folder': 'Создать папку',
	Answer: 'Ответ',
	Price: 'Тариф',
	'Date of creating': 'Дата создания',
	Month: 'Месяц',
	unpaid: 'Не оплачено',
	paid: 'Оплачено',
	'Excluded students': 'Отключенные студенты',
	'Selected groups': 'Выбранные группы',
	Monday: 'Понедельник',
	Tuesday: 'Вторник',
	Wensday: 'Среда',
	Thusday: 'Четверг',
	Friday: 'Пятница',
	Saturday: 'Суббота',
	Sunday: 'Воскресенье',
	Mo: 'Пн',
	Tu: 'Вт',
	We: 'Ср',
	Th: 'Чт',
	Fr: 'Пт',
	Sa: 'Сб',
	Su: 'Вс',
	End: 'Конец',
	'Add discount': 'Добавить скидку',
	Edit: 'Редактировать',
	'Parent found': 'Родитель найден',
	'Changes saved': 'Изменения сохранены',
	'The passwords of the parent and the student should not coincide':
		'Пароли родителя и студента не должны совпадать',
	'Your region`s price is set to': 'Цена вашего региона установлена как ',
	'and the holder`s reward is': 'а награда правовладельца ',
	'regardless of the set price': 'независимо от установленной цены',
	'The given password is not unique for this email':
		'Данный пароль не уникален для этой электронной почты',
	'Enter a valid email address.': 'Введите правильный адрес электронной почты.',
	'The phone number entered is not valid': 'Введенный номер невалидный',
	Holiday: 'Праздники',
	'Working days': 'Рабочие дни',
	Street: 'Улица',
	'Location name': 'Название локации',
	District: 'Район',
	'Mental arithmetic is an oral account technique that rapidly develops the intellectual ability and intelligence of a child between 5 and 14 years of age. The training process takes place on special Japanese accountants Abaсus (Soroban). Mental arithmetic trains simultaneously the left and right hemispheres of the brain, improving visual memory, concentration of attention, creative orientation, imaginative thinking of children and their tendency to fast reading.':
		'Ментальная арифметика  - это методика устного счета которая стремительно развивает умственные способности и интеллект детей возрастом от 5 до 14 лет. Процесс обучения проходит на специальных японских счетах Абакус (Соробан). Ментальная арифметика тренирует одновременно левое и правое полушария мозга, совершенствуя зрительную память, концентрацию внимания, креативную направленность, образное мышление детей и их склонность к скорочтению.',
	'Field required': 'Поле обязательно',
	'Type of legal activity': 'Вид юридической деятельности',
	'Legal address': 'Юридический адрес',
	'Registration number': 'Регистрационный номер',
	'Add Group': 'Добавить группу',
	'Add Student': 'Добавить студента',
	Add: 'Добавить',
	'Add file': 'Добавить файл',
	Signin: 'Вход',
	'Bonus days': 'Бонусные дни',
	'Bonus weeks': 'Бонусные недели',
	'Are you sure you want to delete?': 'Вы уверены, что хотите удалить?',
	Delete: 'Удалить',
	Days: 'Дней',
	Confirm: 'Подтвердить',
	Cancel: 'Отменить',
	Week: 'Неделя',
	Weeks: 'Недели',
	'Group age name': 'Название вековой группы',
	'Set bonus days': 'Выставить бонусные дни',
	'Default language': 'Язык по-умолчанию',
	'With english': 'С английским',
	'Without english': 'Без английского',
	'Paid status': 'Статус оплаты',
	'Not paid': 'Не оплачено',
	Turnover: 'Оборот',
	Block: 'Заблокировать',
	Blocked: 'Заблокированных',
	'On holidays': 'На каникулах',
	Language: 'Язык',
	Discounts: 'Скидки',
	Message: 'Уведомления',
	Subject: 'Тема',
	Homework: 'ДЗ',
	'Homework ': 'Тренировка',
	'Homework on': 'Домашнее задание на',
	'You need to complete the exercises': 'Вам нужно выполнить заданий',
	Homework: 'Домашние задания',
	'Invoice for': 'Счёт на оплату',
	"PJSC CB 'PRIVATBANK' in Kyiv": "ПАТ КБ 'ПРИВАТБАНК' м. Киев",
	Account: 'Счёт',
	Supplier: 'Поставщик',
	Buyer: 'Покупатель',
	'Bank code': 'Код банка ',
	'Type phone number or email':
		'Введите номер телефона или адрес электронной почты',
	'Type password': 'Введите пароль',
	'Forgot password': 'Забыли пароль',
	'Type your email': 'Введите адрес электронной почты',
	Send: 'Отправить',
	'Email sent': 'Письмо отправлено',
	'If you are signed up for the project you will receive email with the next instructions to get back access your account':
		'Если учетная запись с данной электронной почтой существует, мы вышлем письмо восстановления доступа',
	'Back to the sign in': 'Вернуться ко входу на сайт',
	'Password or login is not correct': 'Пароль или логин неверные',
	'Password recovery': 'Восстановление пароля',
	'Type your new password here': 'Введите свой новый пароль',
	'Set new password': 'Установить новый пароль',
	'Learn more': 'Узнать больше',
	'About Us': 'О нас',
	Company: 'Компания',
	Jobs: 'Работа',
	Press: 'Пресса',
	'Terms of Use': 'Условия использования',
	'Privacy Policy': 'Политика конфиденциальности',
	'Need help?': 'Нужна помощь?',
	'Contact us': 'Свяжитесь с нами',
	'Become franchise': 'Франшиза',
	'Select language': 'Выбрать язык',
	English: 'Английский',
	Russian: 'Русский',
	Azerbaijani: 'Азербайджанский',
	Ukrainian: 'Украинский',
	Polish: 'Польский',
	Management: 'Управление',
	'Master Franchise': 'Мастер-франчази',
	Franchise: 'Франчази',
	Teachers: 'Учителя',
	Groups: 'Группы',
	Students: 'Ученики',
	Student: 'Ученик',
	Parents: 'Родители',
	Profile: 'Профиль',
	'My profile': 'Мой профиль',
	Finance: 'Финансы',
	Reports: 'Отчёты',
	Report: 'Отчёт',
	Upload: 'Загрузить',
	List: 'Список',
	Payments: 'Платежи',
	Documents: 'Скан-копии',
	Lessons: 'Уроки',
	Materials: 'Материалы',
	Shop: 'Магазин',
	Statistics: 'Статистика',
	Settings: 'Настройки',
	Pages: 'Страницы',
	Logout: 'Выйти',
	Dashboard: 'Личный кабинет',
	'Access denied': 'Доступ запрещен',
	Create: 'Создать',
	New: 'Новый',
	Download: 'Загрузить',
	Status: 'Статус',
	'Payment Date': 'Дата оплаты',
	'Payment Amount': 'Сумма оплаты',
	'Start time': 'Время начала занятий',
	'Group age': 'Возраст группы',
	Junior: 'Младшие',
	Average: 'Средние',
	Class: 'Класс',
	Older: 'Старшие',
	Region: 'Регион',
	Group: 'Группа',
	Person: 'Особа',
	Finances: 'Финансы',
	Actions: 'К-во действий',
	'Send invoice': 'Счёт-фактура',
	'Download invoice': ' Скачать счёт',
	'Send email': 'Отправить электронное письмо',
	'Create Student': 'Создать ученика',
	'The beginning of holidays': 'Начало праздников',
	'Start of study': 'Начало обучения',
	'Group name': 'Название группы',
	'Group address': 'Адрес группы',
	'Group teacher': 'Учитель группы',
	'Group students': 'Ученики группы',
	'Group statistics': 'Статистика группы',
	Search: 'Поиск',
	'General information': 'Общая информация',
	'Phone number': 'Номер телефона',
	'First name': 'Имя',
	Surname: 'Отчество',
	'Last name': 'Фамилия',
	'Date of birth': 'Дата рождения',
	Password: 'Пароль',
	'Additional information': 'Дополнительная информация',
	'Id code': 'Ид. код',
	Passport: 'Паспорт',
	'Without email newsletter': 'Без email рассылки',
	'With email newsletter': 'С email рассылкой',
	'Financial information': 'Финансовая информация',
	Royalty: 'Роялти',
	'PR contribution': 'PR отчисления',
	Currency: 'Валюта',
	Comment: 'Комментарий',
	Paid: 'Оплаченный',
	Invoices: 'Счет-фактура',
	Bills: 'Законопроекты',
	Acts: 'Акты',
	Scan: 'Скан',
	Level: 'Уровень',
	'Action with numbers': 'К-во действий',
	'Action with number': 'К-во действий',
	'Number of expressions': 'К-во примеров',
	'Number of expression': 'К-во примеров',
	'Imaginary abacus': 'Воображаемые счёты',
	'Period report': 'Отчетный период',
	City: 'Город',
	'Full name franchise': 'ФИО франчайзи',
	'Сost of education': 'Полная цена',
	'Turnover franchise': 'Оборот',
	'Discount sum': 'Сумма скидок',
	Proprietor: 'Роялти',
	'Additional products and services': 'Дополнительные продукты и услуги',
	'Full name student': 'ФИО ученика',
	'Period of study': 'Период обучения',
	'Bonus-days': 'Бонусные дни',
	'Amount of days': 'Количество дней',
	'Total days': 'Всего дней',
	'Language of instruction': 'Язык обучения',
	Teacher: 'Учитель',
	Discount: 'Скидка',
	Remuneration: 'Роялти',
	Goods: 'Товары',
	'Date of creation': 'Дата создания',
	'Date of payment': 'Дата оплаты',
	'Goods (works, services)': 'Товары (роботы, услуги)',
	Quantity: 'Количество',
	Units: 'Единицы',
	Amount: 'Всего',
	Sum: 'Сумма',
	'Sum Sub': 'Форсаж',
	Financial: 'Финансовая',
	Additional: 'Дополнительная',
	General: 'Общая',
	Total: 'Всего',
	Save: 'Сохранить',
	'Including with': 'В том числе',
	'Training materials': 'Обучающие материалы',
	'Learning contract': 'Договор обучения',
	Games: 'Игры',
	'NUMBER OF 11 TO 120': 'ЧИСЛА ОТ 11 ДО 120',
	Complexity: 'Сложность',
	Start: 'Старт',
	'Speedy numbers': 'Форсаж',
	Anzan: 'Анзан',
	'Abacus is random': 'Абакус рандом',
	Multiplication: 'Умножение',
	Division: 'Деление',
	Abacus: 'Абакус',

	'Multiplying by 20': 'умножение до 20',
	Squared: 'возведение в квадрат',
	'Division to 20': 'деление до 20',
	Speed: 'Скорость',
	Repeat: 'Повторения',
	'Game type': 'Тип игры',
	'Digit type': 'Тип чисел',
	Digit: 'Число',
	Time: 'Время',
	Oral: 'Воображаемые счёты',
	Second: 'Секунд',
	'Calculation method': 'Способ счета',
	'Only negative numbers starting with 99,999,9999 etc., depending on the complexity of the expression: -9, -2, -3, -1 ...':
		'Только отрицательные числа, начиная с 99,999,9999 и т.д., в зависимости от сложности примера: -9, -2, -3, -1...',
	'Only subtraction': 'Только вычитание',
	'Only positive numbers starting with 0. Expression: +1, +4, +6, +9, +5 ...':
		'Только сложение, начиная с 0. Пример: +1, +4, +6, +9, +5 ...',
	'Only add': 'Только сложение',
	'Numbers fall randomly, starting with 0. Expression :: +3, -5, -1, +9, -2 ...':
		'Числа выпадают случайным образом, начиная с 0. Пример:: +3, -5, -1, +9, -2 ...',
	'Random numbers': 'Случайные числа',
	'CHOOSE COMPLEXITY:': 'ВЫБЕРИТЕ СЛОЖНОСТЬ:',
	'AMOUNT OF ACTIONS WITH NUMBER': 'КОЛИЧЕСТВО ДЕЙСТВИЙ',
	FAMILY: 'СЕМЬЯ',
	'BIG FRIENDS': 'БОЛЬШИЕ ДРУЗЬЯ',
	'LITTLE FRIENDS': 'МАЛЕНЬКИЕ ДРУЗЬЯ',
	'JUST FRIENDS': 'ПРОСТО ДРУЗЬЯ',
	'big friends': 'большие друзья',
	'small friends': 'маленькие друзья',
	elementary: 'просто друзья',
	family: 'семья',
	Sound: 'Звук',
	'Congratulations! You did it! Now you can go to the following exercises':
		'Отличная работа! Ты – лучше всех!',
	'RIGHT. ANSWER:': 'ПРАВИЛЬНО. ОТВЕТ:',
	CORRECT: 'ПРАВИЛЬНО',
	'NOT CORRECT': 'НЕПРАВИЛЬНО',
	'Try again': 'выполни еще раз',
	expression: 'пример',
	next: 'следующий',
	Next: 'Cледующая',
	Previous: 'Предыдущая',
	Loading: 'Загрузка',
	back: 'назад',
	Back: 'Назад',
	ANSWER: 'ОТВЕТ',
	Lesson: 'Урок',
	'History statistics': 'История статистики',
	Open: 'Открыть',
	'Game statistics per day': 'Статистика игры за день',
	'Total played games': 'Всего сыграно игр',
	'Total correct answers': 'Всего правильных ответов',
	'Total played:': 'Всего сыграно:',
	Feedback: 'Обратная связь',
	'Leave a review': 'Оставить отзыв',
	'Leave us your feedback or wishes and we will definitely consider them in our work.':
		'Оставьте нам свои пожелания и мы обязательно учтём их в работе над продуктом',
	'Payment history': 'История платежей',
	'Payment status': 'Статус оплаты',
	Pay: 'Оплатить',
	Payer: 'Получатель',
	'Getting a discount': 'Получить скидку',
	Training: 'Тренировка',
	Tasks: 'Задача',

	'Current task': 'Текущее задание',
	'Only task': 'Задание',
	'Next tasks': 'Следующие задания',
	'Online abacus': 'Онлайн счёты',
	'Base 50/100': 'База 50/100',
	multiply_base: 'База 50/100',
	divided: 'деленное',
	'Do not show this instruction again': 'Больше не показывать эту инструкцию',
	'Instructions for homework': 'Инструкции для домашних заданий',
	divider: 'делитель',
	'Multiplication table': 'Таблица умножения',
	Restore: 'Восстановить',
	Left: 'Осталось',
	'Restore Hierarchy': 'Восстановить иерархию',
	total: 'всего',
	active: 'активных',
	blocked: 'заблокированных',
	pageError: {
		'403': 'Доступ запрещен.',
		'404': 'Этой страницы не существует. Попробуйте заново.',
		'500': 'Сервер не отвечает. Попробуйте заново.',
	},
	error: {
		'Account deactivated': 'Ваш аккаунт был деактивирован',
	},
	modalNewVersion: {
		text: 'Вы используете устаревшую версию сайта.\nОбновление уже доступно.',
		btn: 'Обновить',
	},
	games: {
		negativeNumbers: 'Отрицательные числа',

		pause: 'Пауза',
		resume: 'Продолжить',

		columns: {
			name: 'Столбцы',
			users: 'Кол-во игроков',
			user: 'Игрок',
			userNames: 'Имена игроков',
		},
	},
	'Indigo-dollars': 'Индиго-доллары',
	Balance: 'Баланс',

	modalIndigoDollars: {
		submit: 'Отправить',
		cancel: 'Отмена',
		title: 'Индиго-доллары',
		balance: 'Текущий баланс',
		amount: 'Количество',
		reason: 'Комментарий',
	},

	modalAddNotification: {
		title: 'Добавить уведомление',
		submit: 'Отправить',
		cancel: 'Отмена',
		empty: 'Нет уведомлений',
	},

	modalTransactionsHistory: {
		title: 'История платежей',
		type: {
			withdraw: 'Списание',
			deposit: 'Пополнение',
		},
		empty: 'Список платежей пуст',
	},

	modalCopyHomework: {
		title: 'Копирование домашнего задания',
		label: 'Выберите дату, на которую нужно копировать домашнее задание',
		submit: 'Копировать',
		cancel: 'Отмена',
	},

	reportsPage: {
		history: {
			title: 'История изменений',
			empty: 'Список пуст',
			table: {
				date: 'Дата изменения',
				field_name: 'Действие',
				old_value: 'Старое значение',
				new_value: 'Новое значение',
				user: 'Изменено у пользователя',
			},
		},
	},

	pageShop: {
		title: 'Магазин',
		description:
			'В магазине вы можете приобрести различные товары для улучшения визуального вида вашего личного кабинета.',

		tabs: {
			all: 'Все товары',
			purchased: 'Купленные',
		},

		item: {
			off_all: 'Нет',

			status: {
				AVAILABLE: 'Рекомендуется',
				DEPRECATED: 'Не доступно',
				COMING_SOON: 'Скоро',
			},
			is_activated: 'Выбрано',
			set_active: 'Выбрать',
			unset_active: 'Отключить',
			preview: 'Посмотреть',
			is_free: 'Бесплатно',
			buy: 'Купить',
			bought: 'Куплено',
			purchased: 'Куплено',
		},
		empty: {
			all: 'Нет доступных улучшений',
			purchased: 'Нет приобретенных улучшений',
		},

		toast: {
			error: 'Произошла ошибка',
			notEnoughMoney: 'Недостаточно средств',
			itemBought: 'Улучшение приобретено',
			itemActivated: 'Улучшение активировано',
			itemDeactivated: 'Улучшение деактивировано',
		},
		confirmPurchase: {
			title: 'Подтверждение покупки',
			message: 'Вы уверены, что хотите купить этот товар?',
			confirm: 'Да, купить',
			cancel: 'Отмена',
		},
	},

	demo: {
		title: 'Бесплатный демо урок',
		tutorial: {
			title: 'Инструкция',
			text:
				'Приветствуем тебя на онлайн демо уроке по ментальной арифметике Indigo Mental.\n Indigo Mental – это лучшая школа по ментальной арифметике в мире, многолетний опыт компании и успех многих учеников по всему миру на олимпиадах доказывают, что данная методика эффективная, уникальная, работающая. Много родителей давно убедились в методике радуются успехам своих детей не только в арифметике, а в других науках, музыке, спорте и отмечают большой скачек в интеллектуальных способностях своего ребенка.\nМентальная арифметика – это японская методика быстрого устного счета, которая стремительно развивает умственные способности и интеллект ребенка. Процесс обучения проходит на специальных японских счетах Абакус (Соробан). Ментальная арифметика тренирует одновременно левое и правое полушария мозга, совершенствуя зрительную память, концентрацию внимания, креативную направленность, образное мышление детей.\nДавай уже приступим к изучению ментальной арифметики, для этого нажми на кнопку “PLAY” на видео ниже, слушай и повторяй.',
		},
	},

	disableStudent: {
		btn: 'Отключить ученика',
		list: 'Ученики без даты деактивации',
		modal: {
			title: 'Отключение ученика',
			description: 'Вы собираетесь отключить ученика',
			fieldLabel: 'Выберите месяц',
			btnSubmit: 'Отключить',
			btnCancel: 'Отмена',
		},
	},
}
